export default __webpack_public_path__ + "static/media/image.master-minds-technologies.56a31ef9.png";